import { useAuth } from 'context/authentication/useAuth'
import { IconType } from 'react-icons'
import styled from 'styled-components'
import { RiUserVoiceLine } from 'react-icons/ri'
import { MdLogout } from 'react-icons/md'
import { Link } from 'react-router-dom'
import { useIsActive } from 'hooks/useIsActive'

interface StyledNavProps {
  $isOpen: boolean
}

const Overlay = styled.div<StyledNavProps>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(6, 81, 47, 0.16);
  opacity: ${(props) => (props.$isOpen ? '1' : '0')};
  visibility: ${(props) => (props.$isOpen ? 'visible' : 'hidden')};
  transition:
    opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    visibility 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 999;
`

const MenuContainer = styled.nav<StyledNavProps>`
  position: fixed;
  top: 12px;
  left: 12px;
  bottom: calc(60px + env(safe-area-inset-bottom) + 12px);
  width: 200px;
  background: white;
  box-shadow: 0px 6px 58px 0px #6e6e6e33;
  transform: translateX(${(props) => (props.$isOpen ? '0' : '-100%')});
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
`

const MenuHeader = styled.div`
  padding: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  gap: 1rem;
`

const MenuTitle = styled.h2`
  margin: 0;
  font-size: 1rem;
  color: #1f2937;
  font-weight: 600;
`

const MenuList = styled.ul`
  list-style: none;
  padding: 1rem 0;
  margin: 0;
  flex: 1;
  overflow-y: auto;
`

const MenuItem = styled.li`
  margin: 0;
  list-style: none;
`

interface MenuLinkProps {
  $isActive: boolean
}

const MenuLink = styled(Link)<MenuLinkProps>`
  display: flex;
  align-items: center;
  margin: 0.5rem 1rem;
  padding: 0.5rem 1rem;
  color: #4b5563;
  text-decoration: none;
  font-size: 1rem;
  transition: all 0.2s ease;
  cursor: pointer;
  border-radius: 6px;

  background: ${(props) => (props.$isActive ? '#e6f1ec' : 'inherit')};
  font-weight: ${(props) => (props.$isActive ? 'bold' : 'inherit')};

  &:hover {
    background: #e6f1ec;
    font-weight: bold;
  }

  svg {
    margin-right: 1rem;
  }
`

const BottomMenu = styled.div`
  color: #4b5563;
`

export type MobileNavItem = {
  label: string
  icon: IconType
  activeIcon: IconType
  to: string
}

type Props = {
  isOpen: boolean
  items: MobileNavItem[]
  onClose?: () => void
}

export default function MobileSlideOutMenu({ items, isOpen, onClose }: Props) {
  const { logout, user } = useAuth()
  const getIsActive = useIsActive()
  console.log(user)

  const handleOverlayClick = () => {
    onClose?.()
  }

  return (
    <>
      <Overlay $isOpen={isOpen} onClick={handleOverlayClick} />
      <MenuContainer $isOpen={isOpen}>
        <MenuHeader>
          <img
            src={user?.company.logos[0].logo_url}
            alt="First Bite"
            width="20px"
          />
          <MenuTitle>{user?.company?.name}</MenuTitle>
        </MenuHeader>

        <MenuList>
          {items.map((item, index) => {
            const isActive = getIsActive(item.to)
            return (
              <MenuItem key={index}>
                <MenuLink to={item.to} $isActive={isActive}>
                  {isActive ? <item.activeIcon /> : <item.icon />}
                  {item.label}
                </MenuLink>
              </MenuItem>
            )
          })}
        </MenuList>

        <BottomMenu>
          <MenuItem className="bg-fb-dark-green rounded-lg mx-3">
            <MenuLink to="#" $isActive={false} className="text-white">
              <RiUserVoiceLine size={20} />
              Help Center
            </MenuLink>
          </MenuItem>

          <MenuItem>
            <MenuLink to="#" onClick={logout} $isActive={false}>
              <MdLogout />
              Logout
            </MenuLink>
          </MenuItem>
        </BottomMenu>
      </MenuContainer>
    </>
  )
}
